import { render, staticRenderFns } from "./AddCoachTask.vue?vue&type=template&id=70e31f9a"
import script from "./AddCoachTask.vue?vue&type=script&lang=ts"
export * from "./AddCoachTask.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports